<template>
    <v-card>
      <v-data-iterator :items='perfResults' no-data-text='当前没有需要您打分的任务。'>
        <template v-slot:header>
          <v-toolbar
            class="mb-2"
            flat
          >
            <v-toolbar-title>绩效打分</v-toolbar-title>
            <v-spacer></v-spacer>
            <template v-if="cur_user && cur_user.isAdmin" >
            <v-btn color="primary" class="ml-2" v-for="(m, i) in recentMonths" :key="i" 
              @click="createNew(m.year, m.month)" :disabled="!cur_user || !cur_user.isAdmin">
              <v-icon left>mdi-chart-box-plus-outline</v-icon>
              创建{{m.month}}月考核
            </v-btn>
            <v-btn color="warning" class="ml-2"
              @click="deletescore(recentMonths[0].year, recentMonths[0].month)" :disabled="!cur_user || !cur_user.isAdmin">
              <v-icon left>mdi-account-multiple-remove</v-icon>
              删除{{recentMonths[0].month}}月考核
            </v-btn>
            </template>
          </v-toolbar>
        </template>
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="(item) in props.items"
              :key="item.name"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card :to="'/perfscorepage/'+item.year+'/'+item.month">
                <v-card-title class="subheading font-weight-bold">
                  {{ item.year }}年{{item.month}}月 {{item.users === item.done_users? '&check;':'&#9756;'}}
                </v-card-title>
                <v-card-text>共{{item.users}}人，已完成{{item.done_users}}人</v-card-text>
                <v-card-actions>
                  <v-row>
                    <v-col cols="4"></v-col>
                    <v-col cols="8">
                      <v-chip class="float-right mr-2" right color="primary" @click="deletescore(item.year, item.month)">
                        打分
                        <v-icon right>mdi-tune-variant</v-icon>
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
      <v-dialog
        v-model="msgdialog"
        width="500"
      >
        <v-card color="error">
          <v-card-title>
            提示
          </v-card-title>
          <v-card-text class="white--text">
            <v-icon>mdi-alert-box-outline</v-icon>
            {{msg}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            color="error"
            @click="dialogcancel()"
            class="text-caption"
            >
            取消
            </v-btn>
            <v-btn
            color="error"
            @click="dialogconfirm()"
            class="text-caption"
            >
            确定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
</template>
<script>
    import { mapState } from 'vuex'

    export default {
        name: 'PerfScore',

        data: () => ({
          perfResults:[],
          recentMonths:[],
          service:null,
          msgdialog:false,
          msg:'',
          dialoglistener:{}
        }),
        computed: {
          ...mapState(['cur_user', 'myCurManageDepartment'])
        },
        created() {
          this.generateMonths()
          this.service = this.$store.getters.service('user-objective-rating')
          this.loadData()
        },
        watch: {
          myCurManageDepartment() {
            this.loadData()
          }
        },
        methods: {
          async loadData() {

            if (this.myCurManageDepartment == null) return
            
            const response = await this.service.find({
              query:{
                'ratedepartments.id': this.myCurManageDepartment.departmentid, 
                customFind:{name:'getYearMonthList'}
              } 
            })

            this.perfResults = response.data
            console.log(`Perfscore reload`)
          },

          generateMonths() {
            const m = (new Date()).getMonth()+1
            const y = (new Date()).getFullYear()

            this.recentMonths.push({year:y, month:m})

            const y1 = m == 1? y-1 : y
            const m1 = m == 1? 12: m -1

            this.recentMonths.push({year:y1, month:m1})
          },
          async createNew(year, month) {
            try{
              const response = await this.service.create({year, month, newMonthRating:true})

              const successusers = response.filter(res => res.status == "fulfilled")
              const successnames = successusers
                .reduce((acc, res) => `${acc}, ${res.value.username}`, '')

              const failedusers = response.filter(res => res.status != "fulfilled")

              console.log(`createNew: ${JSON.stringify(successusers)}-${JSON.stringify(failedusers)}-${successnames}`)

              const msg = failedusers.length === 0 ? '保存成功'
                :(successusers.length != 0 ? `部分保存失败。成功保存的用户名:${successnames}`
                  :`全部保存失败。${JSON.stringify(failedusers[0].reason)}`)

              this.showMsg(msg)
            } catch (e) {
              this.showMsg(`保存出错:${e.message}`)
            }
            this.loadData()
          },
          doesMonthExist(year, month) {
            return this.perfResults.some(pr => pr.year === year && pr.month === month)
          },
          deletescore(year, month) {
            const me = this

            this.showMsg(`将删除${year}年${month}月的所有打分，删除的数据不能恢复。请确认。`, async ()=>{
              console.log(`on confirm.`)
              await me.service.remove(null, {query:{year, month}})
              me.loadData()
            })
          },
          showMsg(msg, onConfirm, onCancel) {
              this.msg = msg
              this.msgdialog = true
              this.dialoglistener.onCancel = onCancel
              this.dialoglistener.onConfirm = onConfirm
          },
          dialogcancel() {
            this.msgdialog = false
            if (this.dialoglistener.onCancel) this.dialoglistener.onCancel()
          },
          dialogconfirm() {
            this.msgdialog = false
            if (this.dialoglistener.onConfirm) this.dialoglistener.onConfirm()
          }
        }
    }
</script>